// Fechas dinámicas del mes actual — siempre visibles en la vista de mes
const now = new Date();
const y = now.getFullYear();
const m = String(now.getMonth() + 1).padStart(2, '0');

interface RawTaskEvent {
  id: string;
  title: string;
  dueDate: string;
  startDate?: string;
}

interface RawTimeEntryEvent {
  id: string;
  description: string;
  startedAt: string;
  durationSeconds: number;
}

export const mockTasks: RawTaskEvent[] = [
  // Día 10 — varias tareas para validar overflow en vista mes
  {
    id: 'task-mock-1',
    title: 'Diseño de wireframes',
    dueDate: `${y}-${m}-10`,
    startDate: `${y}-${m}-08`,
  },
  {
    id: 'task-mock-2',
    title: 'Revisión de PRs',
    startDate: `${y}-${m}-09`,
    dueDate: `${y}-${m}-10`,
  },
  {
    id: 'task-mock-3',
    title: 'Actualizar dependencias',
    dueDate: `${y}-${m}-10`,
  },
  {
    id: 'task-mock-4',
    title: 'Demo con cliente',
    dueDate: `${y}-${m}-15`,
    startDate: `${y}-${m}-15`,
  },
  {
    id: 'task-mock-5',
    title: 'Preparar presentación',
    dueDate: `${y}-${m}-15`,
  },
  {
    id: 'task-mock-6',
    title: 'Entrega de sprint',
    dueDate: `${y}-${m}-20`,
  },
  {
    id: 'task-mock-7',
    title: 'Retrospectiva',
    dueDate: `${y}-${m}-25`,
  },
];

export const mockTimeEntries: RawTimeEntryEvent[] = [
  // Día 10 — registros en la misma fecha que las tareas (mezcla de tipos)
  {
    id: 'te-mock-1',
    description: 'Desarrollo módulo de tareas',
    startedAt: `${y}-${m}-10T09:00:00Z`,
    durationSeconds: 7200,
  },
  {
    id: 'te-mock-2',
    description: 'Reunión de equipo',
    startedAt: `${y}-${m}-10T11:30:00Z`,
    durationSeconds: 3600,
  },
  // Día 15 — junto con las tareas del mismo día
  {
    id: 'te-mock-3',
    description: 'Preparación demo',
    startedAt: `${y}-${m}-15T08:00:00Z`,
    durationSeconds: 5400,
  },
  {
    id: 'te-mock-4',
    description: 'Code review',
    startedAt: `${y}-${m}-18T14:00:00Z`,
    durationSeconds: 5400,
  },
  {
    id: 'te-mock-5',
    description: 'Implementación calendario',
    startedAt: `${y}-${m}-20T09:30:00Z`,
    durationSeconds: 10800,
  },
];
